//store/modules/auth.js
import axios from 'axios';


const getDefaultState = () => ({
  user: null,
  assignedClass:null,
});

const state = getDefaultState();


const getters = {
  isAuthenticated: state => !!state.user,    
  StateUser: state => state.user,
};
const actions = {
  async Register({dispatch}, form) {
    await axios.post('user/signup', form)
    let UserForm = new FormData()
    UserForm.append('email', form.email)
    UserForm.append('password', form.password)
    await dispatch('LogIn', UserForm)
  },

  async LogIn({commit}, User) {
    const response = await axios.post('gym-schedule/client/login', User)
    await commit('setUser', response.data)
  },

  async LogOut({commit, dispatch}){
    let user = null
    try {
      const res = await axios.get('gym-schedule/client/logout');
      dispatch('socketDisconnect');
      dispatch('resetChatState');
      commit('RESET_STATE');
      console.log(res);
    }
    catch(err) {
      console.log(err)
    }
    commit('logout', user)
  },

  async getAssignedClass({commit}){
    const response = await axios.get('gym-schedule/client/assigned/class')
    await commit('setClass', response.data);
  },

  async SetUser({commit}, data) {
    await commit('setUser', data)
  },
  

};
const mutations = {
  setUser(state, user){
      state.user = user
  },
  setClass(state, assignedClass){
      state.assignedClass = assignedClass
  },
  logout(state){
      state.user = null
      state.assignedClass = null
  },
  RESET_STATE(state){
    Object.assign(state, getDefaultState());
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
